import type { SVGProps } from "react";

const ImagePlaceholderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.5" y="3.33333" width="15" height="13.3333" rx="1.66667" stroke="currentColor" strokeWidth="1.45833" />
      <path
        d="M2.5 13.3333L6.66667 9.16667C7.32971 8.50363 8.33696 8.42159 9.09091 9.00568L13.3333 12.5"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 10.8333L12.7576 9.74242C13.4462 9.05387 14.5538 9.05387 15.2424 9.74242L17.5 12"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6.66667" cy="7.5" r="1.25" stroke="currentColor" strokeWidth="1.45833" />
    </svg>
  );
};

export default ImagePlaceholderIcon;
